module.exports = __webpack_public_path__ + "img/40_38_055_570.59610ccd.jpg";